var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { forwardRef } from 'react';
import { Falcon } from 'modules/macro';
import { useGeneratedId } from 'modules/utils';
import { Container, InputContainer, Input, Label } from '../../styled';
import { FragmentWithoutProps } from '../FragmentWithoutProps';
import { StyledOverlay } from './styled';
const iconMap = new Map([
    ['small', <Falcon key={0} icon="circle" $size={8} sourceConfig={{ style: 'solid', family: 'sharp' }}/>],
    ['large', <Falcon key={1} icon="circle" $size={12} sourceConfig={{ style: 'solid', family: 'sharp' }}/>],
]);
export const Radio = forwardRef((props, forwardedRef) => {
    const { id: controlledId, invalid = false, label, required = false, $size = 'small' } = props, restProps = __rest(props, ["id", "invalid", "label", "required", "$size"]);
    const autoId = useGeneratedId('radio');
    const id = controlledId || autoId;
    const Wrapper = label ? Container : FragmentWithoutProps;
    return (<Wrapper>
      <InputContainer $hasLabel={label !== undefined} $size={$size}>
        <Input {...restProps} ref={forwardedRef} id={id} type="radio" required={required} $invalid={invalid}/>
        <StyledOverlay $invalid={invalid}>{iconMap.get($size)}</StyledOverlay>
      </InputContainer>
      {label && <Label htmlFor={id}>{label}</Label>}
    </Wrapper>);
});
